
import api from "../utils/api";
import { getFetch } from "./../utils/request";

const syModel = {
  // 初始化
  init: async (data) => {
    const success = await getFetch(api.syInit, data);
    return success;
  },
  // 获取用户拓展
  userInfo: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 注册 ---
  reg: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 登陆 ==
  login: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 获取token
  getToken: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 获取图形验证码 --
  getImage: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 发送邮箱验证码
  sendEmailCode: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 绑定邮箱
  bindEmail: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 检验邮箱是否绑定
  verifyBindEmail: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 校验邮箱验证码
  validEmailCode: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 修改密码
  changePwdEmail: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 綁定郵箱檢驗郵箱是否綁定
  verifyBindEmailA: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 收集设备信息接口
  webDevice: async (data) => {
    const success = await getFetch(api.syWebDevice, data);
    return success;
  },
  // 埋点数据上报接口
  webDot: async (data) => {
    const success = await getFetch(api.syWebDot, data);
    return success;
  },
  // 错误日志上报接口
  webErrorlog: async (data) => {
    const success = await getFetch(api.syWebErrorlog, data);
    return success;
  },
  // 进入游戏
  getGameUrl: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 客服按钮同步登陆
  kfSync: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 应用充值下单接口
  createOrder: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
};


export default syModel;